import axios from "./axios_interceptor";
import {get_jwt_token, loginRedirect} from './helper_funtions'

// Generic function to get branding configuration
// ownOnly=true: always fetch the logged-in user's own branding (ignores managed_customer_id)
const getBrandingConfig = async (name, requireAuth = true, ownOnly = false) => {
  const managedCustomerId = ownOnly ? null : (
    new URLSearchParams(window.location.search).get('customer_id')
    || localStorage.getItem('managed_customer_id')
  );
  const customerParam = managedCustomerId ? `&customer_id=${managedCustomerId}` : '';
  const url = `/branding/customer-logo-configuration/?name=${name}${customerParam}`;
  try {
    const config = {};
    if (requireAuth) {
      const token = get_jwt_token();
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
    }
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e?.response?.data?.errors || `Failed to load ${name}` };
  }
};

// Logo APIs
export const getBrandingLogo = async () => {
  return getBrandingConfig('logo', true);
};

// Always fetches the logged-in user's own logo (for Header — never swapped by managed_customer_id)
export const getOwnBrandingLogo = async () => {
  return getBrandingConfig('logo', true, true);
};

export const getBrandingLogoForgotPassword = async () => {
  return getBrandingConfig('logo', false);
};

export const setBrandingLogo = async (formField) => {
  const managedCustomerId = new URLSearchParams(window.location.search).get('customer_id')
    || localStorage.getItem('managed_customer_id');
  const url = managedCustomerId ? `/branding/?customer_id=${managedCustomerId}` : "/branding/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

// Favicon APIs
export const getBrandingFavicon = async () => {
  return getBrandingConfig('favicon', true);
};

// Always fetches the logged-in user's own favicon (for browser tab — never swapped by managed_customer_id)
export const getOwnBrandingFavicon = async () => {
  return getBrandingConfig('favicon', true, true);
};

export const getBrandingFaviconForgotPassword = async () => {
  return getBrandingConfig('favicon', false);
};

export const setBrandingFavicon = async (formField) => {
  const managedCustomerId = new URLSearchParams(window.location.search).get('customer_id')
    || localStorage.getItem('managed_customer_id');
  const url = managedCustomerId ? `/branding/?customer_id=${managedCustomerId}` : "/branding/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getOrganisationDomain = async () => {
  const url = "/customer/organisation-name/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const setOrganisationDomain = async (formField) => {
  const url = "/customer/organisation-name/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors?.errors?.message || e.response?.data?.errors || e.message || "An error occurred" };
  }
};